import { envStorage } from "@/utils/envCache";

import zuuAichatbotLogoUrl from "@/assets/HkaiLogin/zuu_aichatbot.png";

export const SOURCE_SYSTEM_STORAGE_KEY = "sourceSystem";
export const DEFAULT_SOURCE_SYSTEM = "default";

export interface SourceSystemConfig {
  code: string;
  title: string;
  logoUrl?: string;
}

export const sourceSystemConfigMap: Record<string, SourceSystemConfig> = {
  [DEFAULT_SOURCE_SYSTEM]: {
    code: DEFAULT_SOURCE_SYSTEM,
    title: "BeeFintech AI",
  },
  "zuu-wxapp": {
    code: "zuu-wxapp",
    title: "芙莉莲（AI ChatBot）",
    logoUrl: zuuAichatbotLogoUrl,
  },
};

export function normalizeSourceSystem(sourceSystem?: string | null): string {
  if (!sourceSystem)
    return DEFAULT_SOURCE_SYSTEM;

  return sourceSystemConfigMap[sourceSystem] ? sourceSystem : DEFAULT_SOURCE_SYSTEM;
}

export function getSourceSystemConfig(sourceSystem?: string | null): SourceSystemConfig {
  return sourceSystemConfigMap[normalizeSourceSystem(sourceSystem)];
}

export function getDefaultSourceSystemConfig(): SourceSystemConfig {
  return sourceSystemConfigMap[DEFAULT_SOURCE_SYSTEM];
}

export function saveSourceSystem(sourceSystem?: string | null): SourceSystemConfig {
  const config = getSourceSystemConfig(sourceSystem);
  envStorage.setItem(SOURCE_SYSTEM_STORAGE_KEY, config.code);
  return config;
}

export function getSavedSourceSystemConfig(): SourceSystemConfig {
  return getSourceSystemConfig(envStorage.getItem(SOURCE_SYSTEM_STORAGE_KEY));
}
